import PageTemplate from "@/components/PageTemplate";
import { SellersHistoric } from "@/App/SellersHistoric";

export function SellersHistoricPage() {
  return (
    <PageTemplate>
      <SellersHistoric />
    </PageTemplate>
  );
}